/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { institutionsAPI } from 'src/api/modules/institutions';
import { organsAPI } from 'src/api/modules/organs';
import { usersAPI } from 'src/api/modules/users';
import notice from 'src/common/components/Notice';
import { usePagination } from 'src/hooks/usePagination';
import { defaultFilter } from '../utils/list_data';
import { transformUsers } from '../utils/transform_users';
import { getAllOrgans } from 'src/utils/getSubOrganos';

const PERMISSIONS = [
	'RESPONSABLE DE ORGANO COLEGIADO',
	'RESPONSABLE DE NEGOCIO',
	'RESPONSABLE DE SEGUIMIENTO',
	'ADMINISTRADOR GENERAL',
	'SISTEMA',
];

export const useDirectory = () => {
	const [hide, setHide] = useState(false);
	const filial = localStorage.getItem('type');
	const [loadingAll, setLoadingAll] = useState(true);
	const [organs, setOrgans] = useState([]);
	const [users, setUsers] = useState([]);
	//const [allUsers, setAllUsers] = useState([]);
	const [byAdvisor, setByAdvisor] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const [filter, setFilter] = useState(defaultFilter);
	const [institutions, setInstitutions] = useState([]);
	const [, setOrganText] = useState('');

	const {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	} = usePagination();

	const systemLevelRole = useMemo(
		() => user?.organos?.[0]?.nombrePerfil?.toUpperCase() ?? '',
		[user]
	);

	const fetchData = async (apiFn, onSuccess, errorMsg, setLoading) => {
		try {
			if (setLoading) setLoading(true);
			const response = await apiFn();
			await onSuccess(response);
		} catch (error) {
			notice(errorMsg, 'error');
		} finally {
			if (setLoading) setLoading(false);
		}
	};

	const getUsers = async (newFilters) => {
		await fetchData(
			async () => await usersAPI.getDirectory(pagination, currentPage, newFilters),
			async (response) => {
				if (response?.usuarios?.length) {
					setUsers(transformUsers(response.usuarios));
					setTotalResults(response?.totalRegistros ?? 0);
				} else {
					setUsers([]);
					setTotalResults(0);
				}
			},
			'Ocurrió un error al cargar los usuarios',
			setLoadingAll
		);
	};

	// const getAllUsers = async (newFilters) => {
	// 	await fetchData(
	// 		async () => await usersAPI.getDirectory('', '', newFilters),
	// 		async (response) => {
	// 			if (response?.usuarios?.length) {
	// 				setAllUsers(transformUsers(response.usuarios));
	// 			} else {
	// 				setAllUsers([]);
	// 			}
	// 		},
	// 		'Ocurrió un error al cargar los usuarios',
	// 		setLoadingAll
	// 	);
	// };

	const getInstitutions = async () => {
		await fetchData(
			async () => await institutionsAPI.get('unidadAdministrativa'),
			async (response) => {
				if (response?.length) {
					const institutionsFlag = response.map((ele) => ({
						value: ele.id,
						text: ele.nombre,
					}));
					setInstitutions(institutionsFlag);
				} else {
					setInstitutions([]);
				}
			},
			'Ocurrió un error al cargar instituciones'
		);
	};

	const getOrgans = async () => {
		if (PERMISSIONS.includes(systemLevelRole) === true && filial === null) {
			await fetchData(
				async () => await organsAPI.get('get'),
				async (response) => {
					if (response?.length) {
						setOrgans(getAllOrgans(response));
					} else {
						setOrgans([]);
					}
				},
				'Ocurrió un error al cargar órganos colegiados'
			);
		} else setOrgans(getAllOrgans(user.organos));
	};

	const onDispatch = async (defaultFilter) => {
		await getUsers(defaultFilter ? defaultFilter : filter);
		//await getAllUsers(defaultFilter ? defaultFilter : filter);
	};

	const onValidate = () => {
		setByAdvisor((prev) => !prev);
	};

	const onClear = async () => {
		setFilter({
			...defaultFilter,
		});

		setTimeout(() => {
			onDispatch(defaultFilter);
		}, 1500);
	};

	const handleChangeFilter = ({ target, currentTarget }) => {
		const { name, value } = target;
		const { innerText } = currentTarget;
		setFilter({ ...filter, [name]: value });
		if (name === 'organo') setOrganText(innerText);
		if (name !== 'consejero') filter.consejero = '';
	};

	const handleChangeUser = (event) => {
		if (event.code !== 'Enter') return;
		const { name, value } = event.target;
		setFilter({ ...filter, [name]: value });
		onDispatch();
	};

	useEffect(() => {
		getOrgans();
		getInstitutions();
		setHide(['ENLACE', 'CONSULTA'].includes(systemLevelRole));
	}, [systemLevelRole]);

	useEffect(() => {
		getUsers(filter);
	}, [pagination, currentPage]);

	// useEffect(() => {
	// 	getAllUsers(filter);
	// }, []);

	return {
		users,
		onDispatch,
		filter,
		handleChangeFilter,
		handleChangeUser,
		onClear,
		onValidate,
		organs,
		institutions,
		byAdvisor,
		permission: PERMISSIONS,
		systemLevelRole,
		hide,
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		handlePagination,
		//allUsers,
		loadingAll,
	};
};
